import { render, staticRenderFns } from "./AppEngAssessmentRoot.vue?vue&type=template&id=6be23e4b&scoped=true"
import script from "./AppEngAssessmentRoot.vue?vue&type=script&lang=ts"
export * from "./AppEngAssessmentRoot.vue?vue&type=script&lang=ts"
import style0 from "./AppEngAssessmentRoot.vue?vue&type=style&index=0&id=6be23e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be23e4b",
  null
  
)

export default component.exports